export default "__VITE_ASSET__437c303f__"